import axios from 'axios';
import { toast } from 'react-toastify';
import { setUserDetails } from '../redux/reducers/user';
import { baseUrl } from '../utils/api';
import { Country,State, } from 'country-state-city';
import { getUserDetails } from './userApis';

export const registerUser =(data,navigate)=> async (dispatch) => {
  try {
    console.log(`Here is base url in frontend ${baseUrl}`)
    const response = await axios.post(`${baseUrl}/auth/register`, {
      firstName:data?.firstName,
      lastName:data.lastName,
      email: data?.email,
      password: data?.password,
      role:data?.role,
    });
    if(response?.status===201){
      dispatch(setUserDetails(response?.data?.user))
      localStorage.setItem("token",JSON.stringify(response?.data?.tokens?.access)) 
     localStorage.setItem("refreshToken", JSON.stringify(response?.data?.tokens?.refresh))
     navigate("/")
      return response?.data?.user;
    }
  } catch (error) {
    if(error?.response?.data){
     const errorMessage=error.response.data.message
     toast.error(errorMessage)
    }
  }
};

export const getSubscriptionEmailDetail =(data,navigate)=> async (dispatch) => {
  try {
    const response = await axios.post(`${baseUrl}/auth/subscribe-email`, {
      email: data?.email
    });
    
    if(response?.status===201){
     navigate("/");
     toast.success()
      return response?.data;
    }
  } catch (error) {
    if(error?.response?.data){
     const errorMessage=error.response.data.message
     toast.error(errorMessage)
    }
  }
};
// export const registerCenter = (data) => async (dispatch) => {
//   try {
//     console.log(data);
    
//     const response = await axios.post(`${baseUrl}/auth/register`, {
//       ...(data?.campaignId && { campaignId: data.campaignId }),
//       centerName: data.centerName,
//       contactPersonName: data?.contactPersonName,
//       email: data?.email,
//       password: data?.password,
//       role: "centerAdmin",
//       firstName: data?.firstName,
//       lastName: data?.lastName,
//       country: Country.getCountryByCode(data.country)?.name,
//       state: State.getStateByCodeAndCountry(data?.state, data?.country)?.name,
//       city: data?.city,
//       phone: data?.phone,
//       address: data?.address,
//       socialMediaLink: data?.socialMediaLink,
//       zipCode: data?.zipCode,
//       description: data?.description,
//       goal: data?.goal,
//       media: data?.media || "", // URL from upload service (S3/GCS)
//     });

//     if (response?.status === 201) {
//       console.log("frontend user details", response?.data?.user);
//       return response?.data?.user;
//     }
//   } catch (error) {
//     if (error?.response?.data) {
//       const errorMessage = error.response.data.message;
//       toast.error(errorMessage);
//     }
//   }
// };

// export const registerCenter = (data) => async (dispatch) => {
//   try {
//     console.log("enetr.................payload")
//     const formData = new FormData();


//     if (data?.campaignId) formData.append("campaignId", data.campaignId);
//     formData.append("centerName", data.centerName);
//     formData.append("contactPersonName", data.contactPersonName);
//     formData.append("email", data.email);
//     formData.append("password", data.password);
//     formData.append("role", "centerAdmin");
//     formData.append(
//       "country",
//       Country.getCountryByCode(data.country)?.name || ""
//     );
//     formData.append(
//       "state",
//       State.getStateByCodeAndCountry(data.state, data.country)?.name || ""
//     );
//     formData.append("city", data.city || "");
//     formData.append("phone", data.phone || "");
//     formData.append("address", data.address || "");
//     formData.append("socialMediaLink", data.socialMediaLink || "");
//     formData.append("zipCode", data.zipCode || "");
//     // 🟡 Strip HTML tags from ReactQuill output before sending
//     const plainTextDescription = data.description.replace(/<[^>]+>/g, '').trim();
//     formData.append("description", plainTextDescription);

//     formData.append("goalAmmount", data.goal || "");

//     // Append the media file
//     if (data.media) {
//       formData.append("media", data.media);
//     }

//     const response = await axios.post(`${baseUrl}/auth/register`, formData, {
//       headers: { "Content-Type": "multipart/form-data" },
//     });

//     if (response?.status === 201) {
//       return response.data.user;
//     }
//   } catch (error) {
//     if (error?.response?.data) {
//       const errorMessage = error.response.data.message;
//       toast.error(errorMessage);
//     }
//   }
// };


const generateSlug = (text = "") =>
  text
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9\s-]/g, "")
    .replace(/\s+/g, "-")
    .replace(/-+/g, "-");

export const registerCenter = (data) => async (dispatch) => {
  try {
    const formData = new FormData();

    if (data.campaignId) formData.append("campaignId", data.campaignId);
    const slug = generateSlug(data.centerName);
   formData.append("userId",data.userId)
    formData.append("centerName", data.centerName || "");
    formData.append("slug", slug);
    formData.append("contactPersonName", data.contactPersonName || "");
    formData.append("email", data.email || "");
    formData.append("phone", data.phone || "");
    formData.append("password", data.password);
    formData.append("role", "centerAdmin");
    // ================= SUPPORTED CAMPAIGN DETAILS (SAVE IN USER) =================
formData.append("address", data.address || "");
formData.append("city", data.city || "");
formData.append("state", data.state || "");
formData.append("zipCode", data.zipCode || "");
formData.append("country", data.country || "");


    // NEW FIELDS YOU ADDED IN BACKEND
    formData.append("campaignType", data.campaignType || "");
    formData.append("organizationName", data.organizationName || "");
    formData.append("contactPreference", data.contactPreference || "");
    formData.append("websiteOrDescription", data.websiteOrDescription || "");
    formData.append("campaignLaunchDate", data.campaignLaunchDate || "");

    // FIXED NAME
    formData.append("goalAmmount", data.goal || "");

    // ================= SMS CONSENT =================
formData.append("smsOptIn", data.smsOptIn ? "true" : "false");

if (data.smsOptIn) {
  formData.append("smsOptInAt", data.smsOptInAt);
  formData.append("smsOptInSource", data.smsOptInSource);
}

    // SAFE DESCRIPTION
    const plainTextDescription =
      data.description
        ? data.description.replace(/<[^>]+>/g, "").trim()
        : "";

    formData.append("description", plainTextDescription);

    // OPTIONAL MEDIA
    if (data.media) {
      formData.append("media", data.media);
    }

    const response = await axios.post(
      `${baseUrl}/auth/register`,
      formData,
      { headers: { "Content-Type": "multipart/form-data" } }
    );

    return response.data;

  } catch (error) {
    console.error("Register center failed:", error);
    throw error;
  }
};


export const login =  (data,navigate)=>async(dispatch) => {
  try {
    const response = await axios.post(`${baseUrl}/auth/login`, {
      email: data?.email,
      password: data?.password,
    });
    if(response?.status===200){
      if(response.data.user.role==="user"){
        dispatch(setUserDetails(response?.data?.user))
       localStorage.setItem("token",JSON.stringify(response?.data?.tokens?.access)) 
       localStorage.setItem("refreshToken", JSON.stringify(response?.data?.tokens?.refresh))
       localStorage.removeItem("email");
       navigate("/")
       return response?.data?.user;
      }else{
        toast.error("User not found ")
      }
    }
  } catch (error) {
    if(error?.response?.data){
     const errorMessage=error.response.data.message
     toast.error(errorMessage)
    }
  }
};


export const logout =  ({navigate})=>async(dispatch) => {
  try {
    const refresh= JSON.parse(localStorage.getItem("refreshToken"))
    const refreshToken=refresh?.token;
    const response = await axios.post(`${baseUrl}/auth/logout`, {
      refreshToken:refreshToken
    });
    if(response?.status===204){
      dispatch(setUserDetails())
      localStorage.removeItem("token");
      localStorage.removeItem("refreshToken")
      navigate('/login')

    }
    return response;
  } catch (error) {
    if(error?.response?.data){
     const errorMessage=error.response.data.message
    }
  }
};

export const forgotPasswordapi =  (data)=>async(dispatch) => {
  try {
    const response = await axios.post(`${baseUrl}/auth/forgot-password`,
    {
      email:data.email
    });
    if(response?.status===200){
      toast.info("Please check your email to reset password")

    }
    return response;
  } catch (error) {
    if(error?.response?.data){
     const errorMessage=error.response.data.message
     toast.error(errorMessage)
    }
  }
};
export const resetPasswordapi =  (data,resetPasswordToken,navigate)=>async(dispatch) => {
  try {
    const response = await axios.post(`${baseUrl}/auth/reset-password?token=${resetPasswordToken}`,
    {
      password:data.newPassword
    });
    if(response?.status===200){
      toast.success(response?.data?.message)
      navigate("/login")

    }
    return response;
  } catch (error) {

    if(error?.response?.data){
     const errorMessage=error.response.data.message
     toast.error(errorMessage)
  
    }
  }
};


 export const refreshToken =  ()=>async(dispatch) => {
  try {
    const refresh= JSON.parse(localStorage.getItem("refreshToken"))
    const refreshToken=refresh?.token;
    const response = await axios.post(`${baseUrl}/auth/refresh-tokens`, {
      refreshToken:refreshToken
    });
    if(response?.status===200||response?.status===201){
      localStorage.setItem("token",JSON.stringify(response?.data?.access)) 
      localStorage.setItem("refreshToken", JSON.stringify(response?.data?.refresh))
      dispatch(getUserDetails())
    }
    return response;
  } catch (error) {
   
    if(error?.response?.data){
     const errorMessage=error.response.data.message
     
    }
  }
}; 

export const bookAppoinment =  (data)=>async(dispatch) => {
  try {
    const response = await axios.post(`${baseUrl}/auth/book-appointment`, 
      {data}
    );
    if(response?.status===200||response?.status===201){
      toast.success("Booking request sent successfully")
   
    }
    return response;
  } catch (error) {
    if(error?.response?.data){
     const errorMessage=error.response.data.message
    }
  }
}; 
export const sendMessage =  (data)=>async(dispatch) => {
  try {
    const response = await axios.post(`${baseUrl}/auth/contact-us`, 
      {data}
    );
    if(response?.status===200||response?.status===201){
      toast.success("Message sent successfully")
   
    }
    return response;
  } catch (error) {
   
    if(error?.response?.data){
     const errorMessage=error.response.data.message
   
    }
  }
}; 


export const sendNewsLetter = (data) => async (dispatch) => {
  try {
    const response = await axios.post(
      `${baseUrl}/auth/subscribenewsletter`,
      data,  // 👈 no {data}, just data
      { headers: { "Content-Type": "application/json" } }
    );

    if (response?.status === 200 || response?.status === 201) {
      toast.success("NewsLetter subscribe successfully");
    }

    return response;
  } catch (error) {
    if (error?.response?.data) {
      const errorMessage = error.response.data.message;
      console.error(errorMessage);
    }
  }
};
